var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9214 1.75H10.0788C10.4175 1.75 10.6946 2.02708 10.6946 2.36574V3.59722C10.6946 3.93588 10.4175 4.21296 10.0788 4.21296H3.9214C3.58275 4.21296 3.30566 3.93588 3.30566 3.59722V2.36574C3.30566 2.02708 3.58275 1.75 3.9214 1.75ZM2.69 4.82863H11.3104C12.3325 4.82863 13.1576 5.65372 13.1576 6.67585V9.13882C13.1576 9.81613 12.6034 10.3703 11.9261 10.3703H10.6946V11.6018C10.6946 12.2791 10.1405 12.8333 9.46315 12.8333H4.53722C3.8599 12.8333 3.30574 12.2791 3.30574 11.6018V10.3703H2.07426C1.39694 10.3703 0.842773 9.81613 0.842773 9.13882V6.67585C0.842773 5.65372 1.66787 4.82863 2.69 4.82863ZM5.15304 11.6019H8.84748C9.18614 11.6019 9.46322 11.3248 9.46322 10.9861V8.52315H4.53729V10.9861C4.53729 11.3248 4.81438 11.6019 5.15304 11.6019ZM11.3104 7.29167C10.9718 7.29167 10.6947 7.01459 10.6947 6.67593C10.6947 6.33727 10.9718 6.06019 11.3104 6.06019C11.6491 6.06019 11.9262 6.33727 11.9262 6.67593C11.9262 7.01459 11.6491 7.29167 11.3104 7.29167Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.5d024db3.svg";
export { ForwardRef as ReactComponent };